import { withReset } from 'store/hors';

import initialState from './initialState';
import reducer from './reducer';

const enhancedReducer = withReset(reducer, initialState);

export { enhancedReducer as reducer };
export * from './actions';
export * from './types';
export * from './selectors';
